import React from "react";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import { useTranslation } from "react-i18next";

const EventHall = () => {
  const { t } = useTranslation();

  return (
    <div class="home page-template-default page page-id-3699 wpb-js-composer js-comp-ver-5.2.1 vc_responsive">
      <Header />
      <div class="content-block">
        <div
          class="container-bg with-bg container-fluid"
          data-style="background-image: url(assets/img/pipacs_wedding_6.webp);"
        >
          <div class="container-bg-overlay">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="page-item-title">
                    <h1 class="text-center texttransform-none">
                      {/* Szobák */}
                      {t("eventHall")}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-container container">
          <div class="row">
            <div class="col-md-12 entry-content">
              <article>
                <div class="vc_row wpb_row vc_row-fluid vc_custom_1502041734192 vc_row-o-equal-height vc_row-flex">
                  <div class="wpb_column vc_column_container vc_col-sm-3">
                    <div class="vc_column-inner vc_custom_1487239752272">
                      <div class="wpb_wrapper"></div>
                    </div>
                  </div>
                  <div class="wpb_column vc_column_container vc_col-sm-6">
                    <div class="vc_column-inner">
                      <div class="wpb_wrapper">
                        <div class="mgt-header-block clearfix text-center text-black wpb_animate_when_almost_visible wpb_fadeInDown fadeInDown wpb_content_element mgt-header-block-style-2 mgt-header-block-fontsize-medium mgt-header-texttransform-none mgt-header-block-43612531">
                          {/* <p class="mgt-header-block-subtitle">{t("rooms")}</p> */}
                          <h2 class="mgt-header-block-title text-font-weight-default">
                            {/* A felejthetetlen pihenésért... */}
                            {t("eventHallPage.intoText")}
                          </h2>
                          <div class="mgt-header-line mgt-header-line-margin-large"></div>
                        </div>
                        <div class="wpb_text_column wpb_content_element wpb_animate_when_almost_visible wpb_fadeInDown fadeInDown text-size-medium">
                          <div class="wpb_wrapper">
                            <p style={{ textAlign: "center" }}>
                              <span style={{ color: "#999999" }}>
                                {/* Ha megpihennél a csodás ételek és borok után, a
                                Pipacs Étterem egyedi, klimatizált szobáiban
                                erre is van lehetőség. A másnap reggelt pedig
                                kezdd a séfünk által összeállított mennyei a’la
                                carte reggelivel! */}
                                {t("eventHallPage.textOne")}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="wpb_text_column wpb_content_element wpb_animate_when_almost_visible wpb_fadeInDown fadeInDown text-size-medium">
                          <div class="wpb_wrapper">
                            <p style={{ textAlign: "center" }}>
                              <span style={{ color: "#999999" }}>
                                {/* Ha megpihennél a csodás ételek és borok után, a
                                Pipacs Étterem egyedi, klimatizált szobáiban
                                erre is van lehetőség. A másnap reggelt pedig
                                kezdd a séfünk által összeállított mennyei a’la
                                carte reggelivel! */}
                                {t("eventHallPage.textTwo")}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="wpb_text_column wpb_content_element wpb_animate_when_almost_visible wpb_fadeInDown fadeInDown text-size-medium">
                          <div class="wpb_wrapper">
                            <p style={{ textAlign: "center" }}>
                              <span style={{ color: "#999999" }}>
                                {/* Ha megpihennél a csodás ételek és borok után, a
                                Pipacs Étterem egyedi, klimatizált szobáiban
                                erre is van lehetőség. A másnap reggelt pedig
                                kezdd a séfünk által összeállított mennyei a’la
                                carte reggelivel! */}
                                {t("eventHallPage.textThree")}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="wpb_text_column wpb_content_element wpb_animate_when_almost_visible wpb_fadeInDown fadeInDown text-size-medium">
                          <div class="wpb_wrapper">
                            <p style={{ textAlign: "center" }}>
                              <span style={{ color: "#999999" }}>
                                {/* Ha megpihennél a csodás ételek és borok után, a
                                Pipacs Étterem egyedi, klimatizált szobáiban
                                erre is van lehetőség. A másnap reggelt pedig
                                kezdd a séfünk által összeállított mennyei a’la
                                carte reggelivel! */}
                                {t("eventHallPage.textFour")}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="wpb_column vc_column_container vc_col-sm-3">
                    <div class="vc_column-inner">
                      <div class="wpb_wrapper"></div>
                    </div>
                  </div>
                </div>
                <div class="vc_row wpb_row vc_row-fluid vc_custom_1502044524324 vc_row-no-padding">
                  <div class="wpb_column vc_column_container vc_col-sm-12">
                    <div class="vc_column-inner">
                      <div class="wpb_wrapper">
                        <div class="mgt-portfolio-grid wpb_content_element">
                          <div
                            class="portfolio-list portfolio-columns-2 portfolio-grid-layout-4 portfolio-with-spaces clearfix"
                            id="portfolio-list-19092996"
                          >
                            <div class="portfolio-item-block text-left">
                              <div class="portfolio-item-block-inside">
                                <a
                                  href="assets/img/pipacs_wedding_2.webp"
                                  target="_self"
                                  rel="lightbox"
                                >
                                  <div
                                    class="portfolio-item-image"
                                    style={{
                                      backgroundImage:
                                        "url(assets/img/pipacs_wedding_1.webp)",
                                    }}
                                  ></div>
                                  <div class="portfolio-item-bg"></div>
                                </a>
                              </div>
                            </div>
                            <div class="portfolio-item-block text-left">
                              <div class="portfolio-item-block-inside">
                                <a
                                  href="assets/img/pipacs_wedding_3.webp"
                                  target="_self"
                                  rel="lightbox"
                                >
                                  <div
                                    class="portfolio-item-image"
                                    style={{
                                      backgroundImage:
                                        "url(assets/img/pipacs_wedding_3.webp)",
                                    }}
                                  ></div>
                                  <div class="portfolio-item-bg"></div>
                                </a>
                              </div>
                            </div>
                            <div
                              class="portfolio-item-block text-left"
                              //   data-item="3"
                              //   data-name="Salmon Tartare"
                            >
                              <div class="portfolio-item-block-inside">
                                <a
                                  href="assets/img/pipacs_wedding_4.webp"
                                  target="_self"
                                  rel="lightbox"
                                >
                                  <div
                                    class="portfolio-item-image"
                                    style={{
                                      backgroundImage:
                                        "url(assets/img/pipacs_wedding_4.webp)",
                                    }}
                                  ></div>
                                  <div class="portfolio-item-bg"></div>
                                </a>
                              </div>
                            </div>
                            <div
                              class="portfolio-item-block text-left"
                              //   data-item="3"
                              //   data-name="Salmon Tartare"
                            >
                              <div class="portfolio-item-block-inside">
                                <a
                                  href="assets/img/pipacs_wedding_5.webp"
                                  target="_self"
                                  rel="lightbox"
                                >
                                  <div
                                    class="portfolio-item-image"
                                    style={{
                                      backgroundImage:
                                        "url(assets/img/pipacs_wedding_5.webp)",
                                    }}
                                  ></div>
                                  <div class="portfolio-item-bg"></div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EventHall;
